

// src/components/Tinnitus.js
import React, { useState, useMemo,useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  Button,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
       Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const Tinnitus = () => {
  // State for search and patient data
 const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
    const [downloadFormat, setDownloadFormat] = useState('excel');
  const [patientFound, setPatientFound] = useState(false);
  const [opNumber, setOpNumber] = useState('');
  const [patientData, setPatientData] = useState(null);
const [demographyData, setDemographyData] = useState(null);
  const [testActivation, setTestActivation] = useState({
    pitch: false,
    loudness: false,
    residualInhibition: false,
    ldl: false,
    thi: false,
    tfi: false,
    stressScale: false,
    anxietyScale: false,
    sleepScale: false
  });
  // State for history section
  const [history, setHistory] = useState({
    nature: '',
    toneType: '',
    episode: '',
    tinnitusType: '',
    time: '',
    duration: '',
    description: ''
  });

  // State for cause of tinnitus
  const [causes, setCauses] = useState({
    otological: '',
    otologicalOther: '',
    medical: '',
    medicalOther: '',
    neurological: '',
    neurologicalOther: '',
    psychological: '',
    psychologicalOther: '',
    other: '',
    otherDetails: ''
  });

  // State for hearing loss
  const [hearingLoss, setHearingLoss] = useState({
    present: false,
    type: '',
    ear: '',
    degree: '',
    configuration: '',
    duration: ''
  });

  // State for amplification
  const [amplification, setAmplification] = useState({
    right: {
      style: '',
      duration: '',
      options: '',
      microphone: '',
      compression: '',
      earmould: '',
      fitting: ''
    },
    left: {
      style: '',
      duration: '',
      options: '',
      microphone: '',
      compression: '',
      earmould: '',
      fitting: ''
    }
  });

  // State for tinnitus tests
  const [tinnitusTests, setTinnitusTests] = useState({
    pitch: {
      right: '',
      left: ''
    },
    loudness: {
      right: '',
      left: ''
    },
    residual: {
      right: '',
      left: ''
    },
    ldl: {
      right: '',
      left: ''
    },
    thiScore: '',
    tfiScore: '',
    stressScore: '',
    anxietyScore: '',
    sleepScore: ''
  });

  // State for evaluation
  const [evaluation, setEvaluation] = useState({
    thiInterpretation: '',
    tfiSubscales: '',
    stressInterpretation: '',
    anxietyInterpretation: '',
    sleepInterpretation: ''
  });

  // State for recommendations
  const [recommendations, setRecommendations] = useState({
    ent: false,
    soundTherapy: false,
    psychology: false,
    neurology: false,
    psychiatric: false,
    yoga: false
  });

  // State for expanded sections
  const [expanded, setExpanded] = useState({
    history: true,
    cause: true,
    hearing: true,
    amplification: true,
    tests: true,
    evaluation: true,
    recommendations: true
  });

  // Helper functions for interpretations
  const calculateThiInterpretation = (score) => {
    const numScore = parseInt(score) || 0;
    if (numScore <= 16) return 'Slight (0-16)';
    if (numScore <= 36) return 'Mild (18-36)';
    if (numScore <= 56) return 'Moderate (38-56)';
    if (numScore <= 76) return 'Severe (58-76)';
    return 'Catastrophic (78-100)';
  };

  const calculateTfiInterpretation = (score) => {
    if (score <= 17) return 'Not a problem (0-17)';
    if (score <= 31) return 'Small problem (18-31)';
    if (score <= 53) return 'Moderate problem (32-53)';
    if (score <= 72) return 'Big problem (54-72)';
    return 'Very big problem (73-100)';
  };

  const calculateStressInterpretation = (score) => {
    const numScore = parseInt(score) || 0;
    if (numScore <= 13) return 'Low stress (0-13)';
    if (numScore <= 26) return 'Moderate stress (14-26)';
    return 'High perceived stress (27-40)';
  };

  const calculateAnxietyInterpretation = (score) => {
    const numScore = parseInt(score) || 0;
    if (numScore <= 7) return 'Normal (0-7)';
    if (numScore <= 10) return 'Borderline abnormal (8-10)';
    return 'Abnormal (11-21)';
  };

  const calculateSleepInterpretation = (score) => {
    const numScore = parseInt(score) || 0;
    if (numScore <= 7) return '0 to 10: Normal';
    if (numScore <= 9) return '11 to 14: Mild';
    if (numScore <= 15) return '15 to 17: Modrate';
    return '18 to 24: Severe';
  };
    useEffect(() => {
  const data = localStorage.getItem("demography");
  if (data) {
    try {
      const parsedData = JSON.parse(data);
      setDemographyData(parsedData);
    } catch (error) {
      console.error("Error parsing demography data:", error);
    }
  }
}, []);

  const [tfiScores, setTfiScores] = useState({
    intrusive: '',
    senseOfControl: '',
    cognitive: '',
    sleep: '',
    auditory: '',
    relaxation: '',
    qualityOfLife: '',
    emotional: ''
  });
const handleSearch = async () => {
  try {
    // Search for patient in the database
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registrations?opNumber=${opNumber}`);
    
    if (!response.ok) {
      throw new Error("Failed to search for patient");
    }
    
    const patients = await response.json();
    
    if (patients.length > 0) {
      setPatientData(patients[0]);
      setPatientFound(true);
    } else {
      setPatientData(null);
      setPatientFound(false);
      alert('Patient not found. Please try another OP number.');
    }
  } catch (error) {
    console.error("Error:", error);
    alert("❌ Failed to search for patient");
  }
};
  const handleHistoryChange = (field, value) => {
    setHistory({ ...history, [field]: value });
  };

  const handleCauseChange = (field, value) => {
    setCauses({ ...causes, [field]: value });
  };

  const handleHearingLossChange = (field, value) => {
    setHearingLoss({ ...hearingLoss, [field]: value });
  };
  const handleTfiSubscaleChange = (subscale, value) => {
    // Validate input to be between 0 and 10
    const numValue = parseInt(value) || 0;
    const clampedValue = Math.min(Math.max(numValue, 0), 10);

    setTfiScores(prev => ({
      ...prev,
      [subscale]: clampedValue.toString()
    }));
  };
  const tfiTotalScore = useMemo(() => {
    const values = Object.values(tfiScores);
    if (values.some(score => score === '')) return 0;

    const sum = values.reduce((total, score) => total + parseFloat(score), 0);
    return (sum / 8) * 10; // TFI formula: average of subscales × 10
  }, [tfiScores]);

  const toggleTestActivation = (test) => {
    setTestActivation(prev => ({
      ...prev,
      [test]: !prev[test]
    }));
  };
  const handleAmplificationChange = (ear, field, value) => {
    setAmplification({
      ...amplification,
      [ear]: {
        ...amplification[ear],
        [field]: value
      }
    });
  };

  const handleTestChange = (field, value) => {
    setTinnitusTests({ ...tinnitusTests, [field]: value });
  };

 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Tinnitus Data ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "tinnitus_data",
          formName: "Tinnitus_Data",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Tinnitus_Data_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

  const handleEvaluationChange = (field, value) => {
    setEvaluation({ ...evaluation, [field]: value });
  };

  const handleRecommendationChange = (name) => (event) => {
    setRecommendations({ ...recommendations, [name]: event.target.checked });
  };

  const toggleSection = (section) => {
    setExpanded({ ...expanded, [section]: !expanded[section] });
  };

// In your Tinnitus component, update the handleSubmit function
const handleSubmit = async () => {
  try {
    // Make sure patientData exists and has an id
    if (!patientData || !patientData.id) {
      throw new Error("Patient information is missing. Please register the patient first.");
    }

    // Prepare data for submission
    const submissionData = {
      patientId: patientData.id,
      date: new Date().toISOString().split('T')[0],
      history,
      causes,
      hearingLoss,
      amplification,
      tinnitusTests: {
        ...tinnitusTests,
        // Ensure numeric fields are numbers or null
        pitch: {
          right: tinnitusTests.pitch.right || null,
          left: tinnitusTests.pitch.left || null
        },
        loudness: {
          right: tinnitusTests.loudness.right || null,
          left: tinnitusTests.loudness.left || null
        },
        ldl: {
          right: tinnitusTests.ldl.right || null,
          left: tinnitusTests.ldl.left || null
        },
        thiScore: tinnitusTests.thiScore || null,
        stressScore: tinnitusTests.stressScore || null,
        anxietyScore: tinnitusTests.anxietyScore || null,
        sleepScore: tinnitusTests.sleepScore || null
      },
      testActivation,
      tfiScores: {
        intrusive: tfiScores.intrusive || null,
        senseOfControl: tfiScores.senseOfControl || null,
        cognitive: tfiScores.cognitive || null,
        sleep: tfiScores.sleep || null,
        auditory: tfiScores.auditory || null,
        relaxation: tfiScores.relaxation || null,
        qualityOfLife: tfiScores.qualityOfLife || null,
        emotional: tfiScores.emotional || null
      },
      tfiTotalScore: tfiTotalScore || null,
      recommendations
    };

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tinnitus`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(submissionData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to save tinnitus data");
    }

    const data = await response.json();
    alert("✅ Tinnitus data saved successfully!");
    console.log("Saved:", data);
  } catch (error) {
    console.error("Error:", error);
    alert(`❌ ${error.message}`);
  }
};


  return (
    <Box sx={{ maxWidth: 1200, margin: 'auto', p: 3, backgroundColor: '#f5f7fa' }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">

          Tinnitus Management System
        </Typography>
<Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
  <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
          Patient Identification
        </Typography>

        {/* Search Section */}
        <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
            <Grid container spacing={3} alignItems="center">
             <Grid item xs={12} md={6}>
          <TextField
            label="OP Number"
            value={opNumber}
            onChange={(e) => setOpNumber(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ flexGrow: 1, mr: 2, backgroundColor: 'white' }}
          />
          </Grid>
          <Grid item xs={12} md={6}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={handleSearch}
            sx={{ px: 4, py: 1.5, fontWeight: 'bold' }}
          >
            Search Patient
          </Button>
          </Grid>
          </Grid>
        </Box>
</Box>
        {/* Patient Information */}
        {patientData && (
          <Paper elevation={2} sx={{ p: 3, mb: 3, backgroundColor: '#e3f2fd', borderRadius: 2 }}>
            
              <Box sx={{ position: 'absolute', top: 350, right: 70 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
            <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

              Patient Information
            </Typography>
            <Grid container spacing={2} mb={4}>
                 <Grid item xs={12} sm={6}>
                   <Typography><strong>Name:</strong> {demographyData.name}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={3}>
                   <Typography><strong>Age:</strong> {demographyData.age}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={3}>
                   <Typography><strong>Gender:</strong> {demographyData.gender}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={6}>
                   <Typography><strong>Phone:</strong> {demographyData.phone}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={6}>
                   <Typography><strong>Address:</strong> {demographyData.address}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={6}>
                   <Typography><strong>Referred by:</strong> {demographyData.referredBy}</Typography>
                 </Grid>
                 <Grid item xs={12} sm={6}>
                   <Typography><strong>Patient op_number:</strong> {demographyData.patientNumber}</Typography>
                 </Grid>
               </Grid>
          </Paper>
        )}
        {patientFound && (
          <>
            {/* History Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Tinnitus History
                </Typography>
                <IconButton onClick={() => toggleSection('history')}>
                  {expanded.history ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expanded.history}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Nature of Tinnitus</InputLabel>
                      <Select
                        value={history.nature}
                        onChange={(e) => handleHistoryChange('nature', e.target.value)}
                        label="Nature of Tinnitus"
                        displayEmpty
                        renderValue={value => value || "Select Nature of Tinnitus"}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="Static">Static</MenuItem>
                        <MenuItem value="Progressive">Progressive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Tone Type</InputLabel>
                      <Select
                        value={history.toneType}
                        onChange={(e) => handleHistoryChange('toneType', e.target.value)}
                        label="Tone Type"
                        displayEmpty
                        renderValue={value => value || "Select Tone Type"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="Low">Low</MenuItem>
                        <MenuItem value="Mid">Mid</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Episode</InputLabel>
                      <Select
                        value={history.episode}
                        onChange={(e) => handleHistoryChange('episode', e.target.value)}
                        label="Episode"
                        displayEmpty
                        renderValue={value => value || "Select Episode"}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="Continuous">Continuous</MenuItem>
                        <MenuItem value="Intermittent">Intermittent</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Time of Tinnitus</InputLabel>
                      <Select
                        value={history.time}
                        onChange={(e) => handleHistoryChange('time', e.target.value)}
                        label="Time of Tinnitus"
                        displayEmpty
                        renderValue={value => value || "Select Time of Tinnitus"}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="Morning">Morning</MenuItem>
                        <MenuItem value="Afternoon">Afternoon</MenuItem>
                        <MenuItem value="Evening">Evening</MenuItem>
                        <MenuItem value="Night">Night</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Tinnitus Type</InputLabel>
                      <Select
                        value={history.tinnitusType}
                        onChange={(e) => handleHistoryChange('tinnitusType', e.target.value)}
                        label="Tinnitus Type"
                        displayEmpty
                        renderValue={value => value || "Select Tinnitus Type"}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="Subjective">Subjective</MenuItem>
                        <MenuItem value="Objective">Objective</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>



                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Duration (months/years)"
                      value={history.duration}
                      onChange={(e) => handleHistoryChange('duration', e.target.value)}
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Description of Tinnitus"
                      value={history.description}
                      onChange={(e) => handleHistoryChange('description', e.target.value)}
                      fullWidth
                      multiline
                      rows={3}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </Paper>

            {/* Cause of Tinnitus Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Cause of Tinnitus
                </Typography>
                <IconButton onClick={() => toggleSection('cause')}>
                  {expanded.cause ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expanded.cause}>
                <Grid container spacing={2}>
                  {/* Otological Causes */}
                  <Grid item xs={12} md={6}>
                    <Typography fontWeight="bold" gutterBottom>Otological Cause:</Typography>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Select Cause</InputLabel>
                      <Select
                        value={causes.otological}
                        onChange={(e) => handleCauseChange('otological', e.target.value)}
                        label="Select Cause"
                        displayEmpty
                        renderValue={value => value || "Select Cause"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Middle ear infection">Middle ear infection</MenuItem>
                        <MenuItem value="Meniere’s Disease">Meniere’s Disease</MenuItem>
                        <MenuItem value="Noise Exposure">Noise Exposure</MenuItem>
                        <MenuItem value="Patent ET">Patent ET</MenuItem>
                        <MenuItem value="Wax blockage">Wax blockage</MenuItem>
                        <MenuItem value="Presbycusis">Presbycusis</MenuItem>
                        <MenuItem value="Sudden SNHL">Sudden SNHL</MenuItem>
                        <MenuItem value="Ear Surgery">Ear Surgery</MenuItem>
                        <MenuItem value="Head and Neck Trauma">Head and Neck Trauma</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                    {causes.otological === 'Other' && (
                      <TextField
                        label="Specify Other Cause"
                        value={causes.otologicalOther}
                        onChange={(e) => handleCauseChange('otologicalOther', e.target.value)}
                        fullWidth
                        size="small"
                      />
                    )}
                  </Grid>

                  {/* Neurological Causes */}
                  <Grid item xs={12} md={6}>
                    <Typography fontWeight="bold" gutterBottom>Neurological Cause:</Typography>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Select Cause</InputLabel>
                      <Select
                        value={causes.neurological}
                        onChange={(e) => handleCauseChange('neurological', e.target.value)}
                        label="Select Cause"
                        displayEmpty
                        renderValue={value => value || "Select Cause"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Acoustic Neuroma">Acoustic Neuroma</MenuItem>
                        <MenuItem value="Stroke">Stroke</MenuItem>
                        <MenuItem value="Multiple sclerosis">Multiple sclerosis</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                    {causes.neurological === 'Other' && (
                      <TextField
                        label="Specify Other Cause"
                        value={causes.neurologicalOther}
                        onChange={(e) => handleCauseChange('neurologicalOther', e.target.value)}
                        fullWidth
                        size="small"
                      />
                    )}
                  </Grid>

                  {/* Medical Causes */}
                  <Grid item xs={12} md={6}>
                    <Typography fontWeight="bold" gutterBottom>Medical Cause:</Typography>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Select Cause</InputLabel>
                      <Select
                        value={causes.medical}
                        onChange={(e) => handleCauseChange('medical', e.target.value)}
                        label="Select Cause"
                        displayEmpty
                        renderValue={value => value || "Select Cause"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Cardiovascular abnormality">Cardiovascular abnormality</MenuItem>
                        <MenuItem value="Anemia">Anemia</MenuItem>
                        <MenuItem value="Hypertension">Hypertension</MenuItem>
                        <MenuItem value="Diabetes">Diabetes</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                    {causes.medical === 'Other' && (
                      <TextField
                        label="Specify Other Cause"
                        value={causes.medicalOther}
                        onChange={(e) => handleCauseChange('medicalOther', e.target.value)}
                        fullWidth
                        size="small"
                      />
                    )}
                  </Grid>

                  {/* Psychological Causes */}
                  <Grid item xs={12} md={6}>
                    <Typography fontWeight="bold" gutterBottom>Psychological Cause:</Typography>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Select Cause</InputLabel>
                      <Select
                        value={causes.psychological}
                        onChange={(e) => handleCauseChange('psychological', e.target.value)}
                        label="Select Cause"
                        displayEmpty
                        renderValue={value => value || "Select Cause"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Anxiety">Anxiety</MenuItem>
                        <MenuItem value="Depression">Depression</MenuItem>
                        <MenuItem value="Stressful condition">Stressful condition</MenuItem>
                        <MenuItem value="Sleep Disturbance">Sleep Disturbance</MenuItem>
                        <MenuItem value="Emotional instability">Emotional instability</MenuItem>
                        <MenuItem value="Social Inhibition">Social Inhibition</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                    {causes.psychological === 'Other' && (
                      <TextField
                        label="Specify Other Cause"
                        value={causes.psychologicalOther}
                        onChange={(e) => handleCauseChange('psychologicalOther', e.target.value)}
                        fullWidth
                        size="small"
                      />
                    )}
                  </Grid>

                  {/* Other Causes */}
                  <Grid item xs={12}>
                    <Typography fontWeight="bold" gutterBottom>Other Cause:</Typography>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel shrink={true}>Select Cause</InputLabel>
                      <Select
                        value={causes.other}
                        onChange={(e) => handleCauseChange('other', e.target.value)}
                        label="Select Cause"
                        displayEmpty
                        renderValue={value => value || "Select Cause"}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Metabolic illness">Metabolic illness</MenuItem>
                        <MenuItem value="Dental factors">Dental factors</MenuItem>
                        <MenuItem value="Drug induced">Drug induced</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                    {causes.other === 'Other' && (
                      <TextField
                        label="Specify Other Cause"
                        value={causes.otherDetails}
                        onChange={(e) => handleCauseChange('otherDetails', e.target.value)}
                        fullWidth
                        size="small"
                      />
                    )}
                  </Grid>
                </Grid>
              </Collapse>
            </Paper>

            {/* Hearing Loss Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Hearing Loss
                </Typography>
                <IconButton onClick={() => toggleSection('hearing')}>
                  {expanded.hearing ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expanded.hearing}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={hearingLoss.present}
                          onChange={(e) => handleHearingLossChange('present', e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Hearing Loss Present"
                    />
                  </Grid>

                  {hearingLoss.present && (
                    <>
                      {/* Ear Dropdown */}
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Ear</InputLabel>
                          <Select
                            value={hearingLoss.ear}
                            onChange={(e) => handleHearingLossChange('ear', e.target.value)}
                            label="Ear"
                            displayEmpty
                            renderValue={value => value || "Select Ear"}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Right">Right</MenuItem>
                            <MenuItem value="Left">Left</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Degree of HL</InputLabel>
                          <Select
                            value={hearingLoss.degree}
                            onChange={(e) => handleHearingLossChange('degree', e.target.value)}
                            label="Degree of HL"
                            displayEmpty
                            renderValue={value => value || "Select Degree of HL"}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Minimal (75 to 90)">Minimal (75 to 90)</MenuItem>
                            <MenuItem value="Mild (50 to 74)">Mild (50 to 74)</MenuItem>
                            <MenuItem value="Moderate (30 to 49)">Moderate (30 to 49)</MenuItem>
                            <MenuItem value="Severe (0 to 29)">Severe (0 to 29)</MenuItem>
                            <MenuItem value="Profound">Profound</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* Type of HL */}
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Type of HL</InputLabel>
                          <Select
                            value={hearingLoss.type}
                            onChange={(e) => handleHearingLossChange('type', e.target.value)}
                            label="Type of HL"
                            displayEmpty
                            renderValue={value => value || "Select Type of HL"}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Conductive">Conductive</MenuItem>
                            <MenuItem value="Mixed">Mixed</MenuItem>
                            <MenuItem value="Sensory Neural">Sensory Neural</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Degree of HL */}


                      {/* Configuration */}
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Configuration</InputLabel>
                          <Select
                            value={hearingLoss.configuration}
                            onChange={(e) => handleHearingLossChange('configuration', e.target.value)}
                            label="Configuration"
                            displayEmpty
                            renderValue={value => value || "Select Configuration"}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Gradually Sloping">Gradually Sloping</MenuItem>
                            <MenuItem value="Steeply Sloping">Steeply Sloping</MenuItem>
                            <MenuItem value="Pre-Sloping">Pre-Sloping</MenuItem>
                            <MenuItem value="Fournouch">Fournouch</MenuItem>
                            <MenuItem value="Cooliebite">Cooliebite</MenuItem>
                            <MenuItem value="Revising">Revising</MenuItem>
                            <MenuItem value="Float">Float</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Duration */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Duration"
                          value={hearingLoss.duration}
                          onChange={(e) => handleHearingLossChange('duration', e.target.value)}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                    </>
                  )}

                </Grid>
              </Collapse>
            </Paper>

            {/* Amplification Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Amplification
                </Typography>
                <IconButton onClick={() => toggleSection('amplification')}>
                  {expanded.amplification ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expanded.amplification}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                        <TableCell>Parameter</TableCell>
                        <TableCell align="center">Right Ear</TableCell>
                        <TableCell align="center">Left Ear</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Style</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.style}
                              onChange={(e) => handleAmplificationChange('right', 'style', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Body level BTE">Body level BTE</MenuItem>
                              <MenuItem value="RCI">RCI</MenuItem>
                              <MenuItem value="ITC">ITC</MenuItem>
                              <MenuItem value="CIC">CIC</MenuItem>
                              <MenuItem value="ITE">ITE</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.style}
                              onChange={(e) => handleAmplificationChange('left', 'style', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Body level BTE">Body level BTE</MenuItem>
                              <MenuItem value="RCI">RCI</MenuItem>
                              <MenuItem value="ITC">ITC</MenuItem>
                              <MenuItem value="CIC">CIC</MenuItem>
                              <MenuItem value="ITE">ITE</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Duration</TableCell>
                        <TableCell>
                          <TextField
                            value={amplification.right.duration}
                            onChange={(e) => handleAmplificationChange('right', 'duration', e.target.value)}
                            fullWidth
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={amplification.left.duration}
                            onChange={(e) => handleAmplificationChange('left', 'duration', e.target.value)}
                            fullWidth
                            size="small"
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>HA Options</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.options}
                              onChange={(e) => handleAmplificationChange('right', 'options', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="DM">DM</MenuItem>
                              <MenuItem value="DNR">DNR</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.options}
                              onChange={(e) => handleAmplificationChange('left', 'options', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="DM">DM</MenuItem>
                              <MenuItem value="DNR">DNR</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Microphone</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.microphone}
                              onChange={(e) => handleAmplificationChange('right', 'microphone', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Directional">Directional</MenuItem>
                              <MenuItem value="Omni">Omni</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.microphone}
                              onChange={(e) => handleAmplificationChange('left', 'microphone', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Directional">Directional</MenuItem>
                              <MenuItem value="Omni">Omni</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Compression Threshold</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.compression}
                              onChange={(e) => handleAmplificationChange('right', 'compression', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="High">High</MenuItem>
                              <MenuItem value="Low">Low</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.compression}
                              onChange={(e) => handleAmplificationChange('left', 'compression', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="High">High</MenuItem>
                              <MenuItem value="Low">Low</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Ear Mould</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.earmould}
                              onChange={(e) => handleAmplificationChange('right', 'earmould', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Regular">Regular</MenuItem>
                              <MenuItem value="Skeleton">Skeleton</MenuItem>
                              <MenuItem value="Complete">Complete</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.earmould}
                              onChange={(e) => handleAmplificationChange('left', 'earmould', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Regular">Regular</MenuItem>
                              <MenuItem value="Skeleton">Skeleton</MenuItem>
                              <MenuItem value="Complete">Complete</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Fitting Formula</TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.right.fitting}
                              onChange={(e) => handleAmplificationChange('right', 'fitting', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Proprietary">Proprietary</MenuItem>
                              <MenuItem value="DSL (i/o)">DSL (i/o)</MenuItem>
                              <MenuItem value="NAL-1">NAL-1</MenuItem>
                              <MenuItem value="NAL-NL2">NAL-NL2</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={amplification.left.fitting}
                              onChange={(e) => handleAmplificationChange('left', 'fitting', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              <MenuItem value="Proprietary">Proprietary</MenuItem>
                              <MenuItem value="DSL (i/o)">DSL (i/o)</MenuItem>
                              <MenuItem value="NAL-1">NAL-1</MenuItem>
                              <MenuItem value="NAL-NL2">NAL-NL2</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Collapse>
            </Paper>

            {/* Tinnitus Tests Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Tinnitus Tests
                </Typography>
              </Box>

              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                      <TableCell>Test Type</TableCell>
                      <TableCell>Parameter</TableCell>
                      <TableCell>Right Ear</TableCell>
                      <TableCell>Left Ear</TableCell>
                      <TableCell>Score</TableCell>
                      <TableCell>Interpretation</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Pitch Test */}
                    <TableRow>
                      <TableCell>Pitch</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.pitch ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('pitch')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.pitch && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Pitch of tinnitus (Hz)</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.pitch.right}
                              onChange={(e) => handleTestChange('pitch', { ...tinnitusTests.pitch, right: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.pitch.left}
                              onChange={(e) => handleTestChange('pitch', { ...tinnitusTests.pitch, left: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Loudness Test */}
                    <TableRow>
                      <TableCell>Loudness</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.loudness ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('loudness')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.loudness && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Loudness of tinnitus (dB)</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.loudness.right}
                              onChange={(e) => handleTestChange('loudness', { ...tinnitusTests.loudness, right: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.loudness.left}
                              onChange={(e) => handleTestChange('loudness', { ...tinnitusTests.loudness, left: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Residual Inhibition Test */}
                    <TableRow>
                      <TableCell>Residual Inhibition</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.residualInhibition ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('residualInhibition')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.residualInhibition && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Residual inhibition</TableCell>
                          <TableCell>
                            <FormControl fullWidth size="small">
                              <Select
                                value={tinnitusTests.residual.right}
                                onChange={(e) => handleTestChange('residual', { ...tinnitusTests.residual, right: e.target.value })}
                              >
                                <MenuItem value="">Select</MenuItem>
                                <MenuItem value="Positive">Positive</MenuItem>
                                <MenuItem value="Negative">Negative</MenuItem>
                                <MenuItem value="Rebound">Rebound</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <FormControl fullWidth size="small">
                              <Select
                                value={tinnitusTests.residual.left}
                                onChange={(e) => handleTestChange('residual', { ...tinnitusTests.residual, left: e.target.value })}
                              >
                                <MenuItem value="">Select</MenuItem>
                                <MenuItem value="Positive">Positive</MenuItem>
                                <MenuItem value="Negative">Negative</MenuItem>
                                <MenuItem value="Rebound">Rebound</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* LDL Test */}
                    <TableRow>
                      <TableCell>LDL</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.ldl ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('ldl')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.ldl && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>LDL (dB)</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.ldl.right}
                              onChange={(e) => handleTestChange('ldl', { ...tinnitusTests.ldl, right: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.ldl.left}
                              onChange={(e) => handleTestChange('ldl', { ...tinnitusTests.ldl, left: e.target.value })}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* THI Test */}
                    <TableRow>
                      <TableCell>THI</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.thi ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('thi')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.thi && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell colSpan={2}>THI Score</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.thiScore}
                              onChange={(e) => handleTestChange('thiScore', e.target.value)}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Interpretation</InputLabel>
                              <Select
                                value={tinnitusTests.thiScore ? calculateThiInterpretation(tinnitusTests.thiScore) : ''}
                                label="Interpretation"
                                displayEmpty
                                renderValue={value => value || "Select Interpretation"}
                              >
                                <MenuItem value="Slight (0-16)">Slight (0-16)</MenuItem>
                                <MenuItem value="Mild (18-36)">Mild (18-36)</MenuItem>
                                <MenuItem value="Moderate (38-56)">Moderate (38-56)</MenuItem>
                                <MenuItem value="Severe (58-76)">Severe (58-76)</MenuItem>
                                <MenuItem value="Catastrophic (78-100)">Catastrophic (78-100)</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* TFI Test */}
                    <TableRow>
                      <TableCell>TFI</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.tfi ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('tfi')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.tfi && (
                      <>
                        {/* TFI Subscales */}
                        <TableRow>
                          <TableCell rowSpan={9}></TableCell>
                          <TableCell>Intrusive</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.intrusive}
                              onChange={(e) => handleTfiSubscaleChange('intrusive', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Sense of control</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.senseOfControl}
                              onChange={(e) => handleTfiSubscaleChange('senseOfControl', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Cognitive</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.cognitive}
                              onChange={(e) => handleTfiSubscaleChange('cognitive', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Sleep</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.sleep}
                              onChange={(e) => handleTfiSubscaleChange('sleep', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Auditory</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.auditory}
                              onChange={(e) => handleTfiSubscaleChange('auditory', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Relaxation</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.relaxation}
                              onChange={(e) => handleTfiSubscaleChange('relaxation', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Quality of life</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.qualityOfLife}
                              onChange={(e) => handleTfiSubscaleChange('qualityOfLife', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Emotional</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            <TextField
                              value={tfiScores.emotional}
                              onChange={(e) => handleTfiSubscaleChange('emotional', e.target.value)}
                              size="small"
                              type="number"
                              inputProps={{ min: 0, max: 10, step: 1 }}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>

                        {/* TFI Total Score */}
                        <TableRow>
                          <TableCell>Total TFI Score</TableCell>
                          <TableCell colSpan={2}></TableCell>
                          <TableCell>
                            {tfiTotalScore.toFixed(1)}
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Interpretation</InputLabel>
                              <Select
                                value={tfiTotalScore ? calculateTfiInterpretation(tfiTotalScore) : ''}
                                label="Interpretation"
                                displayEmpty
                                renderValue={value => value || "Select Interpretation"}
                              >
                                <MenuItem value="Not a problem (0-17)">Not a problem (0-17)</MenuItem>
                                <MenuItem value="Small problem (18-31)">Small problem (18-31)</MenuItem>
                                <MenuItem value="Moderate problem (32-53)">Moderate problem (32-53)</MenuItem>
                                <MenuItem value="Big problem (54-72)">Big problem (54-72)</MenuItem>
                                <MenuItem value="Very big problem (73-100)">Very big problem (73-100)</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Perceived Stress Scale */}
                    <TableRow>
                      <TableCell>Perceived Stress Scale</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.stressScale ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('stressScale')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.stressScale && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell colSpan={2}>Stress Score</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.stressScore}
                              onChange={(e) => handleTestChange('stressScore', e.target.value)}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Interpretation</InputLabel>
                              <Select
                                value={tinnitusTests.stressScore ? calculateStressInterpretation(tinnitusTests.stressScore) : ''}
                                label="Interpretation"
                                displayEmpty
                                renderValue={value => value || "Select Interpretation"}
                              >
                                <MenuItem value="Low stress (0-13)">Low stress (0-13)</MenuItem>
                                <MenuItem value="Moderate stress (14-26)">Moderate stress (14-26)</MenuItem>
                                <MenuItem value="High perceived stress (27-40)">High perceived stress (27-40)</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Hospital Anxiety Depression Scale */}
                    <TableRow>
                      <TableCell>Hospital Anxiety Depression Scale</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.anxietyScale ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('anxietyScale')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.anxietyScale && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell colSpan={2}>Anxiety Score</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.anxietyScore}
                              onChange={(e) => handleTestChange('anxietyScore', e.target.value)}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Interpretation</InputLabel>
                              <Select
                                value={tinnitusTests.anxietyScore ? calculateAnxietyInterpretation(tinnitusTests.anxietyScore) : ''}
                                label="Interpretation"
                                displayEmpty
                                renderValue={value => value || "Select Interpretation"}
                              >
                                <MenuItem value="Normal (0-7)">Normal (0-7)</MenuItem>
                                <MenuItem value="Borderline abnormal (8-10)">Borderline abnormal (8-10)</MenuItem>
                                <MenuItem value="Abnormal (11-21)">Abnormal (11-21)</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      </>
                    )}

                    {/* Sleepiness Scale */}
                    <TableRow>
                      <TableCell>Epworth Sleepiness Scale</TableCell>
                      <TableCell>Perform test?</TableCell>
                      <TableCell colSpan={4}>
                        <RadioGroup
                          row
                          value={testActivation.sleepScale ? 'yes' : 'no'}
                          onChange={() => toggleTestActivation('sleepScale')}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {testActivation.sleepScale && (
                      <>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell colSpan={2}>Sleep Score</TableCell>
                          <TableCell>
                            <TextField
                              value={tinnitusTests.sleepScore}
                              onChange={(e) => handleTestChange('sleepScore', e.target.value)}
                              size="small"
                              type="number"
                              fullWidth
                            />
                          </TableCell>
                          <TableCell colSpan={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Interpretation</InputLabel>
                              <Select
                                value={tinnitusTests.sleepScore ? calculateSleepInterpretation(tinnitusTests.sleepScore) : ''}
                                label="Interpretation"
                                displayEmpty
                                renderValue={value => value || "Select Interpretation"} 
                              >
                                <MenuItem value="0 to 10: Normal">0 to 10: Normal</MenuItem>
                                <MenuItem value="11 to 14: Mild">11 to 14: Mild</MenuItem>
                                <MenuItem value="15 to 17: Moderate">15 to 17: Moderate</MenuItem>
                                <MenuItem value="18 to 24: Severe">18 to 24: Severe</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ mt: 3 }}>
                <Typography variant="body2" color="textSecondary">
                  References:
                </Typography>
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2">
                    <Link href="https://www.das.nh.gov/wellness/docs/percieved%20stress%20scale.pdf" target="_blank" rel="noopener">
                      Perceived Stress Scale Reference
                    </Link>
                  </Typography>
                  <Typography variant="body2">
                    Rishi, P., Rishi, E., Maitray, A., Agarwal, A., Nair, S., & Gopalakrishnan, S. (2017). Hospital anxiety and depression scale assessment of 100 patients before and after using low vision care: A prospective study in a tertiary eye-care setting. Indian journal of ophthalmology, 65(11), 1203.
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <Link href="https://www.uofmhealth.org/conditions-treatments/brain-neurological-conditions/epworth-sleepiness-scale#:~:text=Analyze%20Your%20Score&text=8%2D9%3A%20You%20have%20an,should%20consider%20seeking%20medical%20attention." target="_blank" rel="noopener">
                      Epworth Sleepiness Scale Reference
                    </Link>
                  </Typography>
                </Box>
              </Box>
            </Paper>

            {/* Recommendations Section */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">

                  Recommendations
                </Typography>
                <IconButton onClick={() => toggleSection('recommendations')}>
                  {expanded.recommendations ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>

              <Collapse in={expanded.recommendations}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.ent}
                          onChange={handleRecommendationChange('ent')}
                          color="primary"
                        />
                      }
                      label="ENT Referral"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.soundTherapy}
                          onChange={handleRecommendationChange('soundTherapy')}
                          color="primary"
                        />
                      }
                      label="Sound Therapy"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.psychology}
                          onChange={handleRecommendationChange('psychology')}
                          color="primary"
                        />
                      }
                      label="Psychology Counseling"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.neurology}
                          onChange={handleRecommendationChange('neurology')}
                          color="primary"
                        />
                      }
                      label="Neurology Consultation"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.psychiatric}
                          onChange={handleRecommendationChange('psychiatric')}
                          color="primary"
                        />
                      }
                      label="Psychiatric Evaluation"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={recommendations.yoga}
                          onChange={handleRecommendationChange('yoga')}
                          color="primary"
                        />
                      }
                      label="Yoga and Meditation"
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </Paper>
  <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
            {/* Submit Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmit}
                sx={{ fontSize: '1.1rem', px: 6, py: 1.5, fontWeight: 'bold' }}
              >
                Submit Tinnitus Data
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Tinnitus;